const getCron = async ({ params, api }) => {
  return await api(`cron/${params.id}`)
    .then((res) => {
      return Promise.resolve({ data: res });
    })
};

export default getCron;
